export const sortInOrder = <T>(order: T[]) => {
  return (a: T, b: T): number => {
    const indexA = order.indexOf(a);
    const indexB = order.indexOf(b);

    // Both found in order array - sort by their position
    if (indexA !== -1 && indexB !== -1) {
      return indexA - indexB;
    }

    // Only a is in order array - a comes first
    if (indexA !== -1) {
      return -1;
    }

    // Only b is in order array - b comes first
    if (indexB !== -1) {
      return 1;
    }

    // Neither in order array - maintain relative order
    return 0;
  };
};
